module.exports = __webpack_public_path__ + "img/icon-cancel-white.2700a504.svg";